// extracted by mini-css-extract-plugin
export default {"colors":"accent,neutral,negative,warning,positive","button":"styles_button__2B1+z"};